module.exports = __webpack_public_path__ + "public/images/otm-logo-white.40af40c7d20b84bcf1bf88ae297ca41c.svg";